// src/pages/NotFoundPage.jsx
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 800, color: "primary.main" }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Página no encontrada
      </Typography>
      <Typography variant="body2" color="text.secondary">
        La ruta <strong>{location.pathname}</strong> no existe o no está disponible.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2, textTransform: "none", borderRadius: 2 }}
        onClick={() => navigate("/home")}
      >
        Volver al inicio
      </Button>
    </Box>
  );
}

export default NotFoundPage;
